import { createContext, useContext } from 'react'
import { IRequest } from './types'

export const RequestClientContext = createContext<IRequest | null>(null)

export const useRequestClientContext = () => useContext(RequestClientContext)
